<template>
  <div>
    <button class="btn-add" @click="abrirForm(null)" style="margin-bottom:16px;">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      Agregar producto
    </button>
    <div class="ide-ia-card" style="overflow-x:auto; padding:0;">
      <table style="width:100%; border-collapse:collapse; font-size:12px;">
        <thead style="background:var(--bg-alt); border-bottom:1px solid var(--border);">
          <tr>
            <th style="padding:10px 12px; text-align:left; font-weight:600;">Producto</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Stock</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Mínimo</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!inventarios.length" style="border-bottom:1px solid var(--border);">
            <td colspan="4" style="padding:24px; text-align:center; color:var(--text-disabled);">Sin productos en inventario</td>
          </tr>
          <tr v-for="inv in inventarios" :key="inv.id" style="border-bottom:1px solid var(--border-card);">
            <td style="padding:10px 12px;">
              <div style="font-weight:600; color:var(--text-heading);">{{ inv.productoNombre }}</div>
              <div style="font-size:10px; color:var(--text-faint);">#{{ inv.productoId }}</div>
            </td>
            <td style="padding:10px 12px; text-align:center; font-weight:600;" :style="{ color: inv.stock && inv.stock < inv.stockMinimo ? '#ef4444' : '#22c55e' }">
              {{ inv.stock ?? '∞' }}
            </td>
            <td style="padding:10px 12px; text-align:center;">{{ inv.stockMinimo }}</td>
            <td style="padding:10px 12px; text-align:center; display:flex; gap:4px; justify-content:center;">
              <button @click="abrirForm(inv)" style="background:none; border:none; cursor:pointer; color:#818cf8; font-size:12px; padding:4px;">✏️</button>
              <button @click="eliminarInventario(inv)" style="background:none; border:none; cursor:pointer; color:#ef4444; font-size:12px; padding:4px;">🗑️</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal -->
    <div v-if="dialogForm" class="cat-overlay" @click.self="dialogForm = false">
      <div class="cat-modal" style="max-width:400px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">{{ editando ? 'Editar stock' : 'Agregar producto' }}</span>
          <button @click="dialogForm = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style="overflow-y:auto; padding:18px 22px; max-height:60vh;">
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Producto *</label>
            <select v-model="form.productoId" class="ide-input" :disabled="editando" style="cursor: pointer;">
              <option value="">Selecciona un producto</option>
              <option v-for="p in productosDisponibles" :key="p.id" :value="p.id">{{ p.nombre }}</option>
            </select>
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Stock actual</label>
            <input v-model.number="form.stock" type="number" class="ide-input" placeholder="Dejar vacío para stock ilimitado" />
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Stock mínimo *</label>
            <input v-model.number="form.stockMinimo" type="number" class="ide-input" placeholder="Ej: 5" />
          </div>
          <div style="display:flex; gap:8px; align-items:center;">
            <input type="checkbox" v-model="form.activo" style="width:16px; height:16px;" />
            <label style="font-size:12px; color:var(--text-muted); margin:0;">Activo</label>
          </div>
        </div>
        <div style="display:flex; gap:8px; padding:16px 22px; border-top:1px solid var(--border);">
          <button @click="dialogForm = false" style="flex:1; background:none; border:1px solid var(--border); border-radius:6px; padding:8px; cursor:pointer; color:var(--text-muted); font-family:inherit;">
            Cancelar
          </button>
          <button @click="guardar" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; cursor:pointer; font-family:inherit; font-weight:600;">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventarioSucursal',
  props: {
    sucursalId: [String, Number],
    clienteId: [String, Number],
  },
  data() {
    return {
      inventarios: [],
      productosDisponibles: [],
      dialogForm: false,
      editando: null,
      form: { productoId: '', stock: undefined, stockMinimo: 5, activo: true },
    }
  },
  watch: {
    sucursalId() {
      this.cargar()
    },
  },
  mounted() {
    this.cargar()
    this.cargarProductos()
  },
  methods: {
    async cargar() {
      if (!this.sucursalId) return
      try {
        this.inventarios = await this.$service.list(`sucursales/${this.sucursalId}/inventario`) || []
      } catch (err) {
        this.$message.error('Error al cargar inventario')
      }
    },
    async cargarProductos() {
      try {
        this.productosDisponibles = await this.$service.list('productos', { limit: 999 }) || []
      } catch (err) {
        console.error(err)
      }
    },
    abrirForm(inv) {
      if (inv) {
        this.editando = inv
        this.form = JSON.parse(JSON.stringify({ productoId: inv.productoId, stock: inv.stock, stockMinimo: inv.stockMinimo, activo: inv.activo }))
      } else {
        this.editando = null
        this.form = { productoId: '', stock: undefined, stockMinimo: 5, activo: true }
      }
      this.dialogForm = true
    },
    async guardar() {
      if (!this.form.productoId || this.form.stockMinimo === undefined) {
        this.$message.warning('Producto y stock mínimo son requeridos')
        return
      }
      try {
        const payload = {
          productoId: this.form.productoId,
          stock: this.form.stock !== undefined ? this.form.stock : null,
          stockMinimo: this.form.stockMinimo,
          activo: this.form.activo,
        }
        if (this.editando) {
          await this.$service.put(`sucursales/${this.sucursalId}/inventario/${this.editando.id}`, payload)
          this.$message.success('Stock actualizado')
        } else {
          await this.$service.post(`sucursales/${this.sucursalId}/inventario`, payload)
          this.$message.success('Producto agregado')
        }
        this.dialogForm = false
        this.cargar()
      } catch (err) {
        this.$message.error(err.message || 'Error al guardar')
      }
    },
    async eliminarInventario(inv) {
      if (!confirm(`¿Eliminar producto "${inv.productoNombre}" del inventario?`)) return
      try {
        await this.$service.delete(`sucursales/${this.sucursalId}/inventario/${inv.id}`)
        this.$message.success('Producto removido')
        this.cargar()
      } catch (err) {
        this.$message.error('Error al eliminar')
      }
    },
  },
}
</script>
